import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type GatesAction = ActionType<typeof actions>;

export interface Gate {
  id: number;
  label: string;
}

export enum GatesActionTypes {
  FETCH_REQUEST = "@Gates/FETCH_REQUEST",
  FETCH_SUCCESS = "@Gates/FETCH_SUCCESS",
  FETCH_ERROR = "@Gates/FETCH_ERROR",
  SELECT = "@Gates/SELECT",
  LOGIN_AS_USER = "@Gates/LOGIN_AS_USER",
}

export interface GatesState {
  readonly gates: Gate[];
  readonly isLoaded: boolean;
  readonly selectedGate?: number;
}
